<template>
  <div class="side-bar">
    <p @click="scroll(item, index)" :class="{'active': index === activeIndex}" v-for="(item, index) in sideBarData" :key="index">{{item.value}}</p>
  </div>
</template>

<script>
import { saTrack } from '@xes/dh-sensor';
export default {
  name: "sidebar",
  props: {
    sideBarData: {
      type: Array
    }
  },
  data() {
    return {
      sideBarTop: [],
      activeIndex: null,
      timer: null
    }
  },
  mounted() {
    let {timer} = this, that = this;
    window.addEventListener('scroll', function () {
      if (typeof timer === 'number') {
          clearTimeout(timer);
      }
      timer = setTimeout(function () {
          that.handleScroll()
      },50);
    })
    // window.addEventListener('scroll', this.handleScroll, true);
    this.$nextTick(()=>{
      this.handleScroll();
    })
  },
  methods: {
    scroll(item, index){
      if(!item) return;
      const _sensorParam = this.$route.query.sensorParam;
      if(_sensorParam) {
        const sensorParam = JSON.parse(_sensorParam);
        sensorParam.text_name = item.value;
        saTrack('click_iconsult_web_home_005', sensorParam);
      }
      this.activeIndex = index;
      let _scrollTop = document.getElementById(item.id).offsetTop
      window.scrollTo({
        top: _scrollTop,
        behavior: "smooth"
      })
    },
    handleScroll(){
      let that = this;
      that.sideBarTop=[]
      this.sideBarData.forEach(item=>{
        that.sideBarTop.push(document.getElementById(item.id).offsetTop)
      })
      let _scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(_scrollTop < this.sideBarTop[0]) {
        this.activeIndex = null;
      } else {
        this.sideBarTop.forEach((item,index)=>{
          if(_scrollTop >= item) that.activeIndex = index
        })
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);
  }
};
</script>
<style scoped lang="scss">
.side-bar {
  position: fixed;
  right: 3%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10000;
  width: 90px;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  text-align: center;

  p {
    line-height: 40px;
    font-size: 14px;
    font-weight: 300;
    color: #666;
    cursor: pointer;

    &:hover {
      color: #fff;
      background-color: #cd0014;
    }
  }
  .active {
    color: #fff;
    background-color: #cd0014;
  }
}
@media (min-width: 1400px) {
  .side-bar {
    right: 10%;
  }
}
</style>
